import { Country } from '@src/clients/domain/country';
import {
  CountryCodeField,
  StateField,
} from '@src/clients/financialSettings/fields/CreditCardFields';
import { FormDropdown } from '@src/common/components/FormDropdown';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import type { Control, Path } from 'react-hook-form';

type Fields = {
  [CountryCodeField.fieldName]: string;
  [StateField.fieldName]: string;
};

interface Props<T extends Fields> {
  control: Control<T>;
  selectedCountryCode?: string;
}

export const CountryStateSelect = <T extends Fields>({
  control,
  selectedCountryCode,
}: Props<T>) => {
  const countryOptions = Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.code,
  }));

  const stateOptions = Country.getCountryStates(selectedCountryCode).map(
    (state) => ({
      label: state.name,
      value: state.code,
    }),
  );

  return (
    <Stack direction="row" gap={theme.spacing['3']}>
      <FormDropdown
        control={control}
        fieldName={CountryCodeField.fieldName as Path<T>}
        options={countryOptions}
      />

      <FormDropdown
        control={control}
        disabled={!selectedCountryCode}
        fieldName={StateField.fieldName as Path<T>}
        options={stateOptions}
      />
    </Stack>
  );
};
